import { create } from 'zustand';
import { createSelectors } from '../utils';
import type { TokenType } from './utils';
import { getAuthStatus, getToken, removeToken, setToken } from './utils';

interface AuthState {
  token: TokenType | null;
  status: 'signOut' | 'signIn';
  signIn: (data: TokenType) => void;
  signOut: () => void;
  hydrate: () => void;
}

const _useAuth = create<AuthState>((set, get) => ({
  status: getAuthStatus(),
  token: null,
  signIn: (token) => {
    setToken(token);
    set({ status: 'signIn', token });
  },
  signOut: () => {
    removeToken();
    set({ status: 'signOut', token: null });
  },
  hydrate: () => {
    try {
      const userToken = getToken();
      if (userToken) {
        get().signIn(userToken as TokenType);
      } else {
        get().signOut();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  },
}));
export const useAuth = createSelectors(_useAuth);

export const signOut = () => _useAuth.getState().signOut();
export const signIn = (token: TokenType) => _useAuth.getState().signIn(token);
export const hydrateAuth = () => _useAuth.getState().hydrate();
